module.exports = __webpack_public_path__ + "img/people-management.d05bd221.png";